import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate } from "react-router-dom";

export const developerRoutes: PermissionedRouteObject[] = [
  {
    path: "",
    handle: { breadcrumb: "Developer" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page /> };
    },
    children: [
      { index: true, element: <Navigate replace to="functions" /> },
      {
        path: "functions",
        handle: { breadcrumb: "Functions" },
        async lazy() {
          const { FunctionsListPage } = await import(
            "../../../developer/functions/functions-list-page"
          );
          return { Component: FunctionsListPage };
        },
      },
    ],
  },
];
